import { DialogActions as MuiDialogActions } from '@mui/material';

import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  backgroundColor: theme.palette.background.subtle,
  borderTop: getBorder(theme.palette.border.default),
}));

export { DialogActions };
